import { Route, Routes, useLocation } from 'react-router-dom'
import { ByStudentProvider } from './ByStudentContext/ByStudentContext'
import HeaderContent from './HeaderContent/HeaderContent'
import Module from '../../../../layout/Module'
import LearningMatrix from './LearningMatrix/LearningMatrix'
import LearningGrowth from './LearningGrowth/LearningGrowth'
import LearningGrowthColumnContainer from './LearningGrowthColumn/LearningGrowthColumn'
import CurriculumLevels from './CurriculumLevels/CurriculumLevels'
import ByUnitOfLearning from './ByUl/ByUnitOfLearning'

const ByStudent = () => {
  const { pathname } = useLocation()

  return (
    <ByStudentProvider>
      <HeaderContent pathname={pathname} />
      <Module.BodyContainer classNameWrapper='overflow-auto'>
        <Routes>
          <Route index path='/' element={<LearningMatrix />} />
          <Route path='/learning-matrix' element={<LearningMatrix />} />
          <Route path='/learning-growth-column' element={<LearningGrowthColumnContainer />} />
          <Route path='/learning-growth' element={<LearningGrowth />} />
          <Route path='/curriculum-levels' element={<CurriculumLevels />} />
          <Route path='/by-unit-of-learning' element={<ByUnitOfLearning />} />
        </Routes>
      </Module.BodyContainer>
    </ByStudentProvider>
  )
}

export default ByStudent
